module.exports = __webpack_public_path__ + "img/if_4.69fe740a.png";